import '../../styles/resourceStyle.css';
// import SideBar from '../SideBar';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { url } from '../../api/endpointURL';
import { webURL } from '../../config';
import SideBarSmallScreen from '../SideBarSmallScreen'; 
import AOL_logo from '../../images/business_logo.png';
import { contactEmail, contactEmailSupport, contactNum, fullBusiness, businessAddress } from '../../config';

// Import generic components
import Input from '../../generic_components/Input/Input';
import Button from '../../generic_components/Button/Button';
import Footer from '../../generic_components/Footer/Footer';
import { useToast } from '../../generic_components/Toast/Toast';



const ContactUs = ({type}) => {
    const isSmallScreen = window.innerWidth < 600;
    const [fullName, setFullName] = useState('');
    const [emaillAddress, setEmailAddress] = useState('');
    const [phoneNum, setPhoneNum] = useState('');
    const [subject, setSubject] = useState('');
    const [company, setCompany] = useState('');
    const [question, setQuestion] = useState('');

    const navigate = useNavigate();

    const toast = useToast();
    
    const recipientEmail = type === "support" ? contactEmailSupport : contactEmail;
    // const recipientEmail = "annied@artoflogic.ai";  // Change this next Monday

    const handleSubmitContactUsInfo = async(event) => {
        event.preventDefault();
        try {
            const userData = {
                support_email: recipientEmail,
                user_name: fullName,
                user_email : emaillAddress,
                user_phone_number: phoneNum,
                user_company : company,
                subject : subject,
                user_question : question
            }

            const response = await fetch(`${url}/contact-us`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(userData), 
            });

            const data = await response.json();
        
            if (data.message === 'ok') {
                const successMsg = "Thank you for reaching out! We have received your inquiry and will get back to you within 24 hours.";
                toast.success(successMsg, {
                    hideProgressBar: true,
                    autoClose: 9000
                });
                navigate("/faq");
            }
            else {
                const errorMsg = "Internal server error";
                toast.error(errorMsg, {
                    hideProgressBar: true,
                    autoClose: 9000
                });
            }
        }
        catch (error) {
            toast.error(error.message, {
                hideProgressBar: true,
                autoClose: 9000
            });
            console.error('Error:', error);
        }          
    }

    return (
        <>
        {/* {!isSmallScreen &&  <div className='sidebar-container'>
            <SideBar />
        </div>
        } */}
        <div className='contactus-wrapper'>
            <div className="contactus-container">
                <div className="header">
                    <img src={AOL_logo} style={{width: '80%'}} alt="AOL_logo"></img>
                    <p>Ready to transform your business with AI? Let's start the conversation.</p>
                </div>

                <form id="contactForm" onSubmit={handleSubmitContactUsInfo}>
                    <div className="contact-form-group">
                        <Input label="*Full Name" type="text" id="name" placeholder="Enter your full name" onChange={(event)=> setFullName(event.target.value)} required />
                    </div>

                    <div className="contact-form-group">
                        <Input label="*Email Address" type="email" id="email" placeholder="your.email@company.com" onChange={(event)=> setEmailAddress(event.target.value)} required />
                    </div>

                    <div className="contact-form-group">
                        <Input label="Phone Number" type="tel" id="phone" placeholder="Enter your phone number" onChange={(event)=> setPhoneNum(event.target.value)} />
                    </div>

                    <div className="contact-form-group">
                        <Input label="Company Name" type="text" id="company" placeholder="Your company name" onChange={(event)=> setCompany(event.target.value)} />
                    </div>

                    <div className="contact-form-group">
                        <Input label="*Subject" type="text" id="subject" placeholder="Subject" onChange={(event)=> setSubject(event.target.value)} required />
                    </div>

                    <div className="contact-form-group">
                        <label htmlFor="message">*Your Question</label>
                        <textarea id="message" name="message" placeholder="Type your question here... " onChange={(event)=> setQuestion(event.target.value)} required></textarea>
                    </div>

                    <Button type="submit" className="submit-btn">Submit</Button>
                </form>

                <div className="contact-info">
                    <h3>Get In Touch Directly</h3>
                    <div className="contactus-details">
                        <div className="contact-item">
                            <span className="icon">🏢</span>
                            <div>
                                <div className="business-name">{fullBusiness}</div>
                                <div className="address" dangerouslySetInnerHTML={{ __html: businessAddress }}></div>
                            </div>
                        </div>
                        <div className="contact-item">
                            <span className="icon">📞</span>
                            <div>Call us at <strong>{contactNum}</strong></div>
                        </div>
                        <div className="contact-item">
                            <span className="icon">📧</span>
                            <div>Email us at <strong>{recipientEmail}</strong></div>
                        </div>
                        <div className="contact-item">
                            <span className="icon">🕒</span>
                            <div>Monday - Friday: 8:30 AM - 4:30 PM</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* side bar cards for small screens  */}
        {isSmallScreen && <SideBarSmallScreen/>}

        <div className='contactus-footer'>
            <Footer url={webURL}/> 
        </div>   
        </>
    )
};

export default ContactUs;